import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [];

export const resultAttributes = [
  'url',
  'post_id',
  'post_title',
  'post_body_processed',
  'post_author_avatar',
  'post_author_nickname',
  'post_last_comment_timestamp',
  'post_comment_count',
  'post_follow_uids',
];

export const highlightAttributes = [];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: [
    { field: '_score', order: 'desc' },
    { field: 'post_last_comment_timestamp', order: 'desc' },
  ],
};
